/**
 * ViewSelector.jsx
 * Componente reutilizable para seleccionar tipo de vista
 */
import { Button } from "./ui/button";
import { 
  LayoutGrid, 
  List, 
  Table2, 
  Columns3,
  Kanban
} from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "./ui/tooltip";

const viewOptions = [
  { id: 'table', icon: Table2, label: 'Vista Tabla' },
  { id: 'cards', icon: LayoutGrid, label: 'Vista Tarjetas' },
  { id: 'kanban', icon: Columns3, label: 'Vista Kanban' },
  { id: 'list', icon: List, label: 'Vista Lista' },
];

export default function ViewSelector({ currentView, onViewChange, availableViews = ['table', 'cards', 'kanban', 'list'] }) {
  const filteredOptions = viewOptions.filter(opt => availableViews.includes(opt.id));
  
  return (
    <TooltipProvider>
      <div className="flex items-center gap-1 bg-slate-100 dark:bg-slate-800 rounded-lg p-1">
        {filteredOptions.map(({ id, icon: Icon, label }) => (
          <Tooltip key={id}>
            <TooltipTrigger asChild>
              <Button
                variant={currentView === id ? "default" : "ghost"}
                size="sm"
                className={`h-8 w-8 p-0 ${
                  currentView === id 
                    ? 'bg-white dark:bg-slate-700 shadow-sm' 
                    : 'hover:bg-slate-200 dark:hover:bg-slate-700'
                }`}
                onClick={() => onViewChange(id)}
              >
                <Icon className={`h-4 w-4 ${currentView === id ? 'text-primary' : 'text-slate-500'}`} />
              </Button>
            </TooltipTrigger>
            <TooltipContent>
              <p>{label}</p>
            </TooltipContent>
          </Tooltip>
        ))}
      </div>
    </TooltipProvider>
  );
}

export { viewOptions };
